import React from 'react'
import { IntegrationInterfaceCompanyResponse } from '@/main/models/response';
import { TableCell } from '@mui/material';
import StatusIntegrationCompany from '@/main/components/shared/status/statusIntegrationCompany';
import { convertStringForBoolean } from '@/main/services/utilsString';
import { StatusIntegrationCompanyEnum } from '@/main/services/enum/StatusIntegrationCompanyEnum';
import { getOptionsStatusIntegrationCompany } from '@/main/services/data/data';
import { useNavigate } from 'react-router-dom';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { buildUrlQueryParams } from '@/main/services/utils';
import * as S from './styles';

interface IRowDataIntegrationCompanyProps {
  integrationInterfaceCompany: IntegrationInterfaceCompanyResponse;
}

function RowDataIntegrationCompany({
  integrationInterfaceCompany
}: IRowDataIntegrationCompanyProps) {
  const navigate = useNavigate();

  function handleClickRow(e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) {
    e.preventDefault();
    e.stopPropagation();
    const redirectRoute = buildUrlQueryParams(RoutesConstants.integrationRegister, { guidIntegrationCompany: integrationInterfaceCompany.guid })
    navigate(redirectRoute)
  }

  const optionsStatus = getOptionsStatusIntegrationCompany();
  const statusFormatted =
    convertStringForBoolean(integrationInterfaceCompany.status) ?
      optionsStatus.find((item) => item.key === StatusIntegrationCompanyEnum.Active)! :
      optionsStatus.find((item) => item.key === StatusIntegrationCompanyEnum.Suspended)!;

  return (
    <S.Container $isSizeLong onClick={handleClickRow}>
      <TableCell className='TableCell-SizeSmall'><S.CustomColumn $width='150px' title={integrationInterfaceCompany.companyType}>{integrationInterfaceCompany.companyType}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={integrationInterfaceCompany.companyName}>{integrationInterfaceCompany.companyName}</S.CustomColumn></TableCell>
      <TableCell className='TableCell-SizeMedium'><S.CustomColumn $width='250px' title={integrationInterfaceCompany.service}>{integrationInterfaceCompany.service}</S.CustomColumn></TableCell>
      <TableCell className='TableCell-SizeMedium'><S.CustomColumn $width='250px' title={integrationInterfaceCompany.interface}>{integrationInterfaceCompany.interface}</ S.CustomColumn></TableCell>
      <TableCell className='TableCell-SizeMedium'><S.CustomColumn $width='250px' title={integrationInterfaceCompany.endpoint}>{integrationInterfaceCompany.endpoint}</ S.CustomColumn></TableCell>
      <TableCell className='TableCell-Status'><S.CustomColumn $width='120px'><StatusIntegrationCompany idStatus={statusFormatted.key} name={statusFormatted.value} /></S.CustomColumn></TableCell>
    </S.Container>
  );
}

export default RowDataIntegrationCompany